import { Loader2 } from 'lucide-react';

export const Spinner = () => (
  <div className="h-full flex items-center justify-center">
    <Loader2 className="h-10 w-10 animate-spin" />
  </div>
);
